import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Terms & <span className="text-yellow-500">Conditions</span>
            </h1>
            <p className="text-gray-400">Effective Date: January 1, 2025</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By using PreciseFx's website or platform, you agree to these Terms & Conditions. If you do not agree, you may not use our services.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Eligibility</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>You must be at least 18 years old.</li>
                <li>You must comply with local laws regarding trading and financial transactions.</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Services Provided</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>PreciseFx provides automated AI trading software for Forex and Stock markets.</li>
                <li>We do not guarantee profits. All trading carries risk.</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. User Account Responsibilities</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Keep login credentials secure.</li>
                <li>Notify us immediately of unauthorized access.</li>
                <li>Provide accurate information during registration.</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Deposits & Withdrawals</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Minimum deposit: $100 (or as displayed on the platform).</li>
                <li>Withdrawals processed according to our internal timelines.</li>
                <li>Users are responsible for fees charged by payment processors.</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Risk Disclosure</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>All trading involves risk. You may incur losses.</li>
                <li>Past performance does not guarantee future results.</li>
                <li>Users should only invest what they can afford to lose.</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Intellectual Property</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>All software, logos, graphics, and content are the property of PreciseFx.</li>
                <li>Users may not copy, distribute, or reproduce our intellectual property without permission.</li>
              </ul>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Limitation of Liability</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>PreciseFx is not responsible for market losses, platform downtime, or third-party services.</li>
                <li>Users accept full responsibility for their trading activity.</li>
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Termination</h2>
              <p className="leading-relaxed">
                We may suspend or terminate accounts for violating these Terms or fraudulent activity.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
              <p className="leading-relaxed">
                These Terms are governed by the laws of the United States.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">11. Modifications</h2>
              <p className="leading-relaxed">
                PreciseFx may update Terms & Conditions. Users will be notified via the platform.
              </p>
            </section>

            {/* Section 12 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">12. Contact Information</h2>
              <ul className="space-y-2">
                <li>
                  <span className="font-semibold text-white">Email:</span>{' '}
                  <a href="mailto:support@spreadex.asia" className="text-yellow-500 hover:text-yellow-400">
                    support@spreadex.asia
                  </a>
                </li>
                <li>
                  <span className="font-semibold text-white">Phone:</span>{' '}
                  <span className="text-gray-400">+1 (800) 123-4567</span>
                </li>
              </ul>
            </section>
          </div>

          {/* Important Notice */}
          <div className="mt-16 rounded-2xl p-8 border border-gray-700">
            <h3 className="text-xl font-semibold mb-4 text-gray-300">Risk Disclosure</h3>
            <p className="text-gray-400 leading-relaxed text-sm">
              Trading in financial instruments carries a high level of risk and may not be suitable for all investors. 
              The high degree of leverage can work against you as well as for you. Before deciding to trade, you should 
              carefully consider your investment objectives, level of experience, and risk appetite. There is a possibility 
              that you may sustain a loss of some or all of your initial investment. You should only invest money that you 
              can afford to lose.
            </p>
          </div>

          {/* CTA Section */}
          <div className="mt-8 bg-gradient-to-r from-yellow-900/30 to-gray-900 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold mb-4">Questions About Our Terms?</h3>
            <p className="text-gray-400 mb-6">
              Our support team is available to clarify any questions you may have.
            </p>
            <a
              href="/contact"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-3 rounded-xl transition-all duration-300"
            >
              Contact Support
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
